<script lang="ts">
  export let section;
  export let template;
  import viewport from "../helpers/useViewportAction";
  import baseConfig from "../base/baseConfig";
  import qs from "query-string";

  export let version;
  var clientWidth;
  var clientHeight;
  const iframeId = `${template.folder}-frame`;

  const templateConfig = template?.config || {};
  const config = { ...baseConfig, ...templateConfig };
  // @ts-ignore
  const queryParam = qs.stringify(config);

  const location = btoa(
    new URL(`../${template.folder}/`, document.baseURI).href.replace(
      "/latest/",
      `/${version}/`
    )
  );

  var iframe;

  var preview = false;
  var previewDelay = false;
  const simlink = `../simulator/?ipad=false&name=${template.folder.toUpperCase()}&minimal=true&ub64=${location}`;

  var hovering = false;
  var outerContainer;

  var enablePreview = () => {
    preview = true;
    previewDelay = true;
    if (outerContainer) {
      setTimeout(() => {
        let c = document.getElementById(section);
        c.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, 300);
    }
  };

  var disablePreview = () => {
    preview = false;
    const iframe = document.getElementById(iframeId);
    // @ts-ignore
    iframe.contentWindow.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      previewDelay = false;
      hovering = false;
    }, 300);
  };

  var mouseleave = () => {
    hovering = false;
    // disablePreview();
  };

  var mouseover = () => {
    hovering = true;
  };

  $: if (preview) {
    window.document.body.classList.add("no-scroll");
  } else {
    window.document.body.classList.remove("no-scroll");
  }

  var xPreviewPadding = 50;
  var yPreviewPadding = 50;

  $: {
    xPreviewPadding = clientWidth * 0.2;
    yPreviewPadding = clientHeight * 0.2;
  }

  let paywallURL = new URL(
    `../${template.folder}/`,
    document.baseURI
  ).href.replace("/latest/", `/${version}/`);

  var bgcolorHex;

  var launchlink = `https://superwall.com/paywalls/new?url=${encodeURIComponent(
    `${paywallURL}?${queryParam}`
  )}&name=${encodeURIComponent("Template | " + template.folder.toUpperCase())}`;

  var isLoaded = false;

  const didLoad = () => {
    isLoaded = iframe.src != "about:blank";
    if (isLoaded) {
      bgcolorHex = iframe.contentWindow.Superwall.paywallBackgroundColor;
      if (bgcolorHex) {
        launchlink = `${launchlink}&backgroundColorHex=${encodeURIComponent(
          bgcolorHex
        )}`;
      }
    }
  };

  const setIframeSource = () => {
    setTimeout(() => {
      if (!!iframe.src && iframe.src !== "about:blank") return;

      iframe.src = `../${template.folder}/`;
    }, Math.floor(Math.random() * 100));
  };
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->

<div
  style="flex-shrink: 0; --g-preview-y-padding: 75px; --g-preview-x-padding: 0px"
  class="outer"
  bind:this={outerContainer}
  class:preview
  class:preview-delay={previewDelay}
  class:hovering
  on:mousemove={mouseover}
  on:mouseover={mouseover}
  on:mouseenter={mouseover}
  on:mouseleave={mouseleave}
>
  <div class="cover" on:click={disablePreview} />
  <div class="header">
    <div style="opacity: 0;">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        ><title>e-remove</title><g fill="#75fff1"
          ><path
            fill="#75fff1"
            d="M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z"
          /></g
        ></svg
      >
    </div>
    <h1>{template.folder}</h1>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      ><title>e-remove</title><g fill="currentColor"
        ><path
          fill="currentColor"
          d="M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z"
        /></g
      ></svg
    >
  </div>
  <div
    class="inner"
    class:isLoaded
    style="width: calc(min(330.4px * 0.9,max(195px,min(18vw,27.7vh))) * {preview
      ? 1.15
      : 1.0}); height: calc(min(715px * 0.9,max(422px,min(60vh,38.95vw))) * {preview
      ? 1.15
      : 1.0}); transform-origin: center center;"
    bind:clientHeight
    bind:clientWidth
  >
    <iframe
      id={iframeId}
      bind:this={iframe}
      use:viewport
      on:enterViewport={setIframeSource}
      on:load={didLoad}
      class:isLoaded
      title={template.folder}
      width="390px"
      loading="lazy"
      height="844px"
      style="transform: scale({Math.min(clientWidth / 390, clientHeight / 844) *
        0.98}); transform-origin: top center; border-radius: {(30 /
        Math.min(clientWidth / 390, clientHeight / 844)) *
        0.98} px;"
    />
    <div
      class="iframe-cover"
      on:click={enablePreview}
      style="width: {clientWidth}px !important; height: {clientHeight -
        15}px !important;"
    />
  </div>
  <div class="bottom-buttons">
    <!-- svelte-ignore a11y-missing-attribute -->
    <a class="select-button hidden" href={simlink}
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        ><title>edit-brightness</title><g fill="currentColor"
          ><path
            d="M13,6a.75.75,0,0,1-.75-.75,1.5,1.5,0,0,0-1.5-1.5.75.75,0,0,1,0-1.5,1.5,1.5,0,0,0,1.5-1.5.75.75,0,0,1,1.5,0,1.5,1.5,0,0,0,1.5,1.5.75.75,0,0,1,0,1.5,1.5,1.5,0,0,0-1.5,1.5A.75.75,0,0,1,13,6Z"
            data-color="color-2"
          /><path
            d="M6,16a1,1,0,0,1-1-1,4,4,0,0,0-4-4A1,1,0,0,1,1,9,4,4,0,0,0,5,5,1,1,0,0,1,7,5a4,4,0,0,0,4,4,1,1,0,0,1,0,2,4,4,0,0,0-4,4A1,1,0,0,1,6,16Z"
            fill="currentColor"
          /></g
        ></svg
      ><span>Tweak</span></a
    >
    <a href={launchlink} class="select-button last" style="position: relative;">
      <span>Try it</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <title>arrow-right</title>
        <g fill="currentColor">
          <path
            d="M10.707,2.293A1,1,0,0,0,9.293,3.707L12.586,7H1A1,1,0,0,0,1,9H12.586L9.293,12.293a1,1,0,1,0,1.414,1.414l5-5a1,1,0,0,0,0-1.414Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </a>
  </div>
</div>

<style>
  * {
    text-align: left;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    width: 100%;
    padding: 23px;
    padding-top: 0px;
    opacity: 0.2;
    transition: opacity 300ms ease-in-out;
    position: relative;
    z-index: 9;
    pointer-events: none;
  }

  .header svg {
    pointer-events: none;
    opacity: 0;
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
    color: white;
    transform: scale(0.3);
  }

  .preview .header svg {
    opacity: 0.4;
    transform: scale(1);
  }

  h1 {
    text-transform: uppercase;
    font-size: 1.8rem;
    text-align: center;
    font-weight: 400;
  }

  .preview .header {
    opacity: 0.8;
  }

  .preview .inner,
  .preview-delay .inner {
    transition: all 300ms ease-in-out;
  }

  .bottom-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    opacity: 0;
    transition: opacity 100ms ease-in-out;
  }

  .hovering .bottom-buttons {
    opacity: 1;
  }

  .inner {
    overflow: hidden;
  }

  .iframe-cover {
    position: absolute;
    background-color: rgba(0, 0, 0, 0);
    flex-shrink: 0;
    justify-self: stretch;
    align-self: stretch;
    z-index: 1;
    cursor: pointer;
  }

  .preview .iframe-cover {
    display: none;
  }

  a {
    color: #75fff1;
    font-weight: 600;
    font-size: 0.9rem;
    text-decoration: none;
    padding: auto 50px;
    opacity: 0.8;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    border-radius: 14px;
    height: 50px;
    gap: 10px;
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
  }

  a:hover {
    opacity: 1;
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
    transform: scale(1.05);
    /* font-weight: 800; */
  }

  a:active,
  a:focus {
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
    transform: scale(0.97);
  }

  .outer {
    margin: 0px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: padding 300ms ease-in-out, height 300ms ease-in-out;
  }

  .preview.outer {
    padding: var(--g-preview-y-padding) var(--g-preview-x-padding);
  }

  .inner {
    flex-shrink: 0;
    margin: 0px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  iframe {
    flex-shrink: 0;
    margin: 0px;
    padding: 0px;
    border: none;
    background-color: black;
    border-radius: 30px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.05);
    pointer-events: none;
    transition: opacity 300ms ease-in-out;
    opacity: 0;
  }

  iframe.isLoaded {
    opacity: 1;
  }

  .iframe-cover {
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out,
      background-color 300ms ease-in-out;
    background-color: rgba(255, 255, 255, 0.03);
    border-radius: 28px;
    border: 2px solid rgba(255, 255, 255, 0.02);
  }

  .isLoaded .iframe-cover {
    background-color: rgba(255, 255, 255, 0);
    border: 0px;
  }

  .preview iframe {
    pointer-events: all;
    border: 3px solid rgba(255, 255, 255, 0.3);
  }

  .preview .inner,
  .preview .bottom-buttons,
  .preview h1 {
    position: relative;
    z-index: 100;
  }

  .cover {
    position: fixed;
    z-index: 20;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  .preview .cover {
    opacity: 1;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(10, 10, 10, 0.85);
    /* pointer-events: none; */
  }

  a {
    cursor: pointer;
  }

  .select-button.last,
  .select-button.last {
    background-color: #75fff1;
    color: black;
    border-radius: 15px;
    flex-shrink: 1;
    transition: all 300ms ease-in-out;
    transition-delay: 100ms;
  }

  .bottom-buttons {
    padding-left: 20px;
    padding-right: 20px;
  }

  .hidden {
    display: none;
  }

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .loader {
    width: 30px;
    height: 30px;
    border: 4px solid #2e3030;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
